// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__Set from "melange/set.js";
import * as Stdlib__String from "melange/string.js";

const Ids = Stdlib__Set.Make({
  compare: Stdlib__String.compare
});

const initial_ids = Ids.empty;

const initial = {
  items: /* [] */ 0,
  ids: initial_ids,
  loaded_tip: undefined,
  next_cursor: undefined,
  draft: "",
  attempt: undefined,
  message: ""
};

function ids_of(items) {
  return Stdlib__List.fold_left((function (set, c) {
    return Curry._2(Ids.add, c.id, set);
  }), Ids.empty, items);
}

function ordered(a, b) {
  if (a.created_at === b.created_at) {
    return Caml.caml_string_compare(a.id, b.id);
  } else {
    return Caml.caml_float_compare(a.created_at, b.created_at);
  }
}

function merge(existing, fresh) {
  if (!fresh) {
    return existing;
  }
  if (!existing) {
    return fresh;
  }
  const ys = fresh.tl;
  const y = fresh.hd;
  const xs = existing.tl;
  const x = existing.hd;
  if (x.id === y.id) {
    return {
      hd: y,
      tl: merge(xs, ys)
    };
  } else if (ordered(x, y) <= 0) {
    return {
      hd: x,
      tl: merge(xs, fresh)
    };
  } else {
    return {
      hd: y,
      tl: merge(existing, ys)
    };
  }
}

function decode_comment(json) {
  const value = Js__Js_json.decodeNumber(Mapre_wire__Json.get(json, "created_at"));
  let tmp;
  if (value !== undefined) {
    tmp = value;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_comment_time"
      });
  }
  return {
    id: Mapre_wire__Json.string(json, "id"),
    actor_id: Mapre_wire__Json.string(json, "actor_id"),
    body: Mapre_wire__Json.string(json, "body"),
    created_at: tmp
  };
}

function decode(json) {
  return [
    Stdlib__Array.to_list(Stdlib__Array.map(decode_comment, Mapre_wire__Json.array(json, "comments"))),
    Js__Js_json.decodeString(Mapre_wire__Json.get(json, "next_cursor"))
  ];
}

function decode_posted(json) {
  return decode_comment(Mapre_wire__Json.get(json, "comment"));
}

function last(l) {
  const match = Stdlib__List.rev(l);
  if (match) {
    return Caml_option.some(match.hd);
  }
  
}

function update(t, c) {
  let page;
  let next_cursor;
  if (/* tag */ typeof c !== "object" && typeof c !== "function") {
    if (c === /* Uncertain */ 0) {
      return {
        items: t.items,
        ids: t.ids,
        loaded_tip: t.loaded_tip,
        next_cursor: t.next_cursor,
        draft: t.draft,
        attempt: Stdlib__Option.map((function (a) {
          return {
            id: a.id,
            text: a.text,
            uncertain: true
          };
        }), t.attempt),
        message: t.message
      };
    } else {
      return t;
    }
  }
  switch (c.TAG) {
    case /* Loaded */ 0 :
      const fresh = c._0;
      const items = merge(t.items, fresh);
      const match = t.loaded_tip;
      const match$1 = last(fresh);
      const deeper_loaded = match !== undefined ? (
          match$1 !== undefined ? ordered(match, match$1) > 0 : true
        ) : false;
      const match$2 = t.loaded_tip;
      const match$3 = last(fresh);
      return {
        items,
        ids: ids_of(items),
        loaded_tip: match$2 !== undefined ? (
            match$3 !== undefined ? (
                ordered(match$2, match$3) < 0 ? match$3 : match$2
              ) : t.loaded_tip
          ) : (
            match$3 !== undefined ? match$3 : t.loaded_tip
          ),
        next_cursor: deeper_loaded ? t.next_cursor : c._1,
        draft: t.draft,
        attempt: t.attempt,
        message: t.message
      };
    case /* Appended */ 1 :
      page = c._0;
      next_cursor = c._1;
      break;
    case /* Polled */ 2 :
      const page$1 = c._0;
      if (t.next_cursor !== undefined) {
        const items$1 = merge(t.items, page$1);
        return {
          items: items$1,
          ids: ids_of(items$1),
          loaded_tip: t.loaded_tip,
          next_cursor: t.next_cursor,
          draft: t.draft,
          attempt: t.attempt,
          message: t.message
        };
      }
      page = page$1;
      next_cursor = c._1;
      break;
    case /* Posted */ 3 :
      const items$2 = merge(t.items, {
        hd: c._0,
        tl: /* [] */ 0
      });
      return {
        items: items$2,
        ids: ids_of(items$2),
        loaded_tip: t.loaded_tip,
        next_cursor: t.next_cursor,
        draft: "",
        attempt: undefined,
        message: t.message
      };
    case /* Started */ 4 :
      return {
        items: t.items,
        ids: t.ids,
        loaded_tip: t.loaded_tip,
        next_cursor: t.next_cursor,
        draft: t.draft,
        attempt: c._0,
        message: ""
      };
    case /* Failed */ 5 :
      return {
        items: t.items,
        ids: t.ids,
        loaded_tip: t.loaded_tip,
        next_cursor: t.next_cursor,
        draft: t.draft,
        attempt: undefined,
        message: c._0
      };
    case /* Draft */ 6 :
      return {
        items: t.items,
        ids: t.ids,
        loaded_tip: t.loaded_tip,
        next_cursor: t.next_cursor,
        draft: c._0,
        attempt: t.attempt,
        message: t.message
      };
  }
  const items$3 = merge(t.items, page);
  const match$4 = last(page);
  return {
    items: items$3,
    ids: ids_of(items$3),
    loaded_tip: match$4 !== undefined ? last(page) : t.loaded_tip,
    next_cursor,
    draft: t.draft,
    attempt: t.attempt,
    message: t.message
  };
}

function tip(t) {
  return Stdlib__Option.map((function (c) {
    return c.id;
  }), t.loaded_tip);
}

function can_submit(t) {
  if (t.attempt === undefined && Stdlib__String.trim(t.draft) !== "") {
    return t.draft.length <= 4000;
  } else {
    return false;
  }
}

function body(a) {
  return JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "request_id",
      Mapre_wire__Json.str(a.id)
    ],
    tl: {
      hd: [
        "body",
        Mapre_wire__Json.str(a.text)
      ],
      tl: /* [] */ 0
    }
  }));
}

export {
  Ids,
  initial,
  decode,
  decode_posted,
  update,
  tip,
  can_submit,
  body,
}
/* Ids Not a pure module */
